import { useState } from 'react';/**

 * Custom hook that provides a default state if one isn't passed in. This is helpful in form
 * components that should have the option to have state passed in from a parent.
 *
 * @param {*} value The value for the state variable. This will be used as the default for internal state if setValue isn't passed in
 * @param {*} setValue The setter for value
 *
 * @example
 * // using internal state
 * const [value, setValue] = useDefaultInternalState();
 * @example
 * // using provided state from parent
 * const [value1, setValue1] = useState();
 * const [value2, setValue2] = useDefaultInternalState(value1, setValue1);
 * // value1 === value2 and setValue1 === setValue2
 * @returns {Array} Array of provided state if value and setValue are passed in as parameters. Array of internal state otherwise.
 */

export const useDefaultInternalState = (value?: any, setValue?: (value: any) => void) => {
    const [internalValue, setInternalValue] = useState(value);
    return setValue ? [value, setValue] : [internalValue, setInternalValue];
};
